var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { arrangementTags } from '@cpsy-rmap-project/tags';
import { pickBy, isEmpty } from 'lodash';
import { firestoredData } from '../utils/firebase';
var removeUndefinedValue = function (obj) {
    return pickBy(obj, function (value, _key) { return value !== undefined; }); // 便宜上
};
/** Paperをfirestore登録用に整形する */
export var shapingPaper = function (_a) {
    var paper = _a.paper, uid = _a.uid, serverTimestamp = _a.serverTimestamp, isInitial = _a.isInitial;
    var shapedPaper = __assign({}, firestoredData({
        data: formatPaper({ paper: paper }),
        uid: uid,
        serverTimestamp: serverTimestamp,
        isInitial: isInitial
    }));
    return shapedPaper;
};
/** Paperのデータを整理する */
export var formatPaper = function (_a) {
    var paper = _a.paper;
    // DOIの形式の確認（空ではないが、形式が異なるデータの場合エラーとする）
    if (!isEmpty(paper.doi) && !paper.doi.match(/.+\/.+/u)) {
        throw new Error("\uD83D\uDD25 doi\u306E\u5F62\u5F0F\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093 -> " + paper.doi);
    }
    return removeUndefinedValue(__assign({ authors: paper.authors, title: paper.title, journal: paper.journal, year: paper.year, doi: isEmpty(paper.doi) ? '' : String(paper.doi).toLowerCase(), citedCount: paper.citedCount, type: paper.type, url: paper.url, abstract: paper.abstract, rdocConstructs: arrangementTags('rdocConstructs', paper.rdocConstructs), unitOfAnalysis: arrangementTags('unitOfAnalysis', paper.unitOfAnalysis), dsm5: arrangementTags('dsm5', paper.dsm5), compMathMethodExperimentalDesign: arrangementTags('compMathMethodExperimentalDesign', paper.compMathMethodExperimentalDesign), compMathMethodDataType: arrangementTags('compMathMethodDataType', paper.compMathMethodDataType), compMathMethodModels: arrangementTags('compMathMethodModels', paper.compMathMethodModels), symptomatology: arrangementTags('symptomatology', paper.symptomatology), hypothesis: paper.hypothesis, prediction: paper.prediction, comment: paper.comment, relevantPapers: paper.relevantPapers, draftByAutoTag: paper.draftByAutoTag, pmid: paper.pmid, crid: paper.crid }, (process.env.REACT_APP_DEBUG === 'true' ? { debug: paper.debug } : {})));
};
